import { render, staticRenderFns } from "./WillisLogo.vue?vue&type=template&id=94f50916&"
import script from "./WillisLogo.vue?vue&type=script&lang=js&"
export * from "./WillisLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports